import { render, staticRenderFns } from "./VColgroup.vue?vue&type=template&id=d9ffaf10&scoped=true&"
import script from "./VColgroup.vue?vue&type=script&lang=js&"
export * from "./VColgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ffaf10",
  null
  
)

export default component.exports